<mandates-base-banner
  [active]="active"
  type="success"
  [message]="'MANDATE-ACTIONS.ACTIONS-AWAITING-BANNER' | translate"
  link="/mandates/actions">
</mandates-base-banner>
